/* eslint-disable eol-last */
import React, { useState, useEffect } from "react";
import { Field, useFormikContext } from "formik";

import ElectronicAddress from "../ElectronicAddress";
import ResidentialPhysicalAddressForm from "./ResidentialPhysicalAddressShared";
import ReactSelectWithFormik from "components/lib/Shared/DropdownSelect";
import countyOptions from "components/PLCTABS/SFLdata/countyOptions";

// Residential Address Specific Details For Kenyan Citizen && Foreign Resident
const ResidentialAddressDetailsLoCo = (props) => {
  const { field, form, disabled, disableEmailAddress } = props;
  const { setFieldValue } = useFormikContext();
  const [isLoaded, setIsLoaded] = useState(false);
  const { county = "", district = "", locality = "" } = field?.value ?? {};

  const [dropdownData, setDropdownData] = useState({
    county: countyOptions.residence.county,
    district: [],
    locality: [],
  });

  useEffect(() => {
    setDropdownData({
      ...dropdownData,
      district: countyOptions.residence.district.filter(
        (item) => item.county === county
      ),
      locality: countyOptions.residence.locality.filter(
        (item) => item.district === district
      ),
    });
  }, [setDropdownData]);

  useEffect(() => {
    if (isLoaded) {
      setFieldValue(field.name, {
        ...field.value,
        district: "",
        locality: "",
      });
    }
  }, [county, setFieldValue]);

  useEffect(() => {
    if (isLoaded) {
      setFieldValue(field.name, {
        ...field.value,
        locality: "",
      });
    }
  }, [district, setFieldValue]);

  useEffect(() => setIsLoaded(true), []);

  const handleSelect = (type) => (option) => {
    if (type === "county") {
      setDropdownData({
        ...dropdownData,
        district: countyOptions.residence.district.filter(
          (item) => item.county === option.value
        ),
      });
    }
    if (type === "district") {
      setDropdownData({
        ...dropdownData,
        locality: countyOptions.residence.locality.filter(
          (item) => item.district === option.value
        ),
      });
    }
    setFieldValue(field.name, {
      ...field.value,
      [type]: option.value,
    });
  };

  return (
    <>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <Field
        name="electronicAddress"
        component={ElectronicAddress}
        disabled={disabled}
        disableEmailAddress={disableEmailAddress}
      />
      <div className="px-4 mt-4 space-y-4 bg-white shadow-sm sm:rounded-sm sm:p-6">
        <ResidentialPhysicalAddressForm {...props} />
        <div className="grid grid-cols-6 gap-6">
          <div className="col-span-6 sm:col-span-2">
            <Field
              {...field}
              label="County"
              value={county}
              name="county"
              form={form}
              component={ReactSelectWithFormik}
              options={countyOptions.residence.county}
              errorPath="residentialAddressDetails.county"
              placeholder="Select county"
              isDisabled={disabled}
              onBlur={field.onBlur}
              onChange={handleSelect("county")}
              isSearchable
            />
          </div>
          <div className="col-span-6 sm:col-span-2">
            <Field
              {...field}
              label="District"
              value={district}
              name="district"
              form={form}
              component={ReactSelectWithFormik}
              options={dropdownData.district}
              errorPath="residentialAddressDetails.district"
              placeholder="Select district"
              isDisabled={disabled}
              onBlur={field.onBlur}
              onChange={handleSelect("district")}
              isSearchable
            />
          </div>
          <div className="col-span-6 sm:col-span-2">
            <Field
              {...field}
              label="Locality"
              value={locality}
              name="locality"
              form={form}
              component={ReactSelectWithFormik}
              options={dropdownData.locality}
              errorPath="residentialAddressDetails.locality"
              placeholder="Select locality"
              isDisabled={disabled}
              onBlur={field.onBlur}
              onChange={handleSelect("locality")}
              isSearchable
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ResidentialAddressDetailsLoCo;
